const TimeZoneSelect = () => {
  const timeZone = new Date().toString().match(/([A-Z]+[-][0-9]+.*)/)[1];
  return (
    <div className='timeZoneSelect'>
      <label form='timezone-select'>Select your time zone:</label><br/>
      <select name='timezone' id='timezone-select'>
        <option value=''>{timeZone}</option>
      </select>
    </div>
  )
}

export default TimeZoneSelect